import { Link, Typography, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router';

const InfoTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 400,
    // fontSize: theme.typography.pxToRem(12),
    fontSize: 16,
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const propTypes = {
  classes: PropTypes.object.isRequired,
  formDefinition: PropTypes.object.isRequired,
};

function OrderInfoFormDefinition({ classes, formDefinition }) {
  const answerValueRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  const currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const formatAnswerText = text => {
    switch (formDefinition.answerType) {
      case 'Address':
      case 'Number of items':
      case 'Float':
      case 'Percentage':
      case 'TextBox':
      case 'TextArea':
      case 'Read Only':
      case 'DATE':
        return text;
      case 'Currency':
        return currency.format(text);
      default:
        console.log('This answer type is not recogized: ', formDefinition.answerType);
    }
  };

  const getAnswerValue = () => {
    if (formDefinition.answers.length !== 0 && formDefinition.answers[0].text !== null) {
      return formatAnswerText(formDefinition.answers[0].text);
    } else {
      return '';
    }
  };

  const createGoogleMapsUrl = address => {
    return `https://maps.google.com/?q=${address}`;
  };

  const answerValue = getAnswerValue(formDefinition.answers);
  const googleMapsUrl = createGoogleMapsUrl(answerValue);

  useEffect(() => {
    if (
      !showTooltip &&
      answerValueRef.current &&
      answerValueRef.current.scrollWidth > answerValueRef.current.offsetWidth
    ) {
      setShowTooltip(true);
    }
  }, []);

  // Section headers have no answer to show in the order info bar
  if (formDefinition.answerType === 'Header') {
    return null;
  }

  const answerLabel = (
    <Typography ref={answerValueRef} variant="subtitle2" className={classes.toolbarAttribute} noWrap>
      {formDefinition.questionValue}
      <br />
      {formDefinition.answerType === 'Address' ? (
        <Link className={classes.link} variant="subtitle1" href={googleMapsUrl} target="_blank" rel="noreferrer">
          {answerValue}
        </Link>
      ) : (
        <span>{answerValue !== '' ? answerValue : 'None'}</span>
      )}
    </Typography>
  );

  if (showTooltip) {
    return (
      <InfoTooltip
        interactive // doesn't close if the tooltip is hovered over
        title={answerValue}
      >
        {answerLabel}
      </InfoTooltip>
    );
  }

  return answerLabel;
}

const styles = theme => ({
  toolbarAttribute: {
    color: '#5e80ae',
    lineHeight: 'normal',
    display: 'inline-block',
    textTransform: 'capitalize',
    textAlign: 'left',
    margin: '0.25rem 0',

    '& span': {
      color: '#fff',
    },
    // '& *': {
    //   fontSize: 16
    // }
  },
  link: {
    color: '#fff',
    textDecoration: 'underline',
  },
});

OrderInfoFormDefinition.propTypes = propTypes;

export default withStyles(styles)(withRouter(OrderInfoFormDefinition));
